/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-23, 16:28:53
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-05, 14:57:33
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  servicesList: [],
  servicesBanners: [],
  hasServiceStatusBeenChange: false,
  responseCode: 200,
  servicesListLoading: false,
  changeStatusLoading: false,
  packageUsage: {},
  getUsageLoading: false,
  confirmationRequired: false,
  smsCode: '',
  enabled: false,
  incorrect_code: false,
  selectedCategory: null,
};

const getters = {
  servicesList: state => state.servicesList,
  servicesBanners: state => state.servicesBanners,
  hasServiceStatusBeenChange: state => state.hasServiceStatusBeenChange,
  responseCode: state => state.responseCode,
  servicesListLoading: state => state.servicesListLoading,
  changeStatusLoading: state => state.changeStatusLoading,
  packageUsage: state => state.packageUsage,
  getUsageLoading: state => state.getUsageLoading,
  confirmationRequired: state => state.confirmationRequired,
  smsCode: state => state.smsCode,
  enabled: state => state.enabled,
  incorrect_code: state => state.incorrect_code,
  selectedCategory: state => state.selectedCategory,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Services/index.js